import { createRouter, createWebHistory } from "vue-router";
import { check } from "@/repositories/auth.ts";
import HomeView from "../views/HomeView.vue";
import { useAccount } from "@/stores/account.ts";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "home",
      component: HomeView,
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/LoginView.vue"),
    },
    {
      path: "/register",
      name: "register",
      component: () => import("@/views/RegisterView.vue"),
    },
  ],
});

router.beforeEach(async (to) => {
  let account;

  try {
    account = await check();
  } catch {
    // The session could not be verified at all (backend down, network gone). That is not the same
    // as being signed out, so do not drop the profile and do not push the visitor to the login
    // screen: cancel the navigation and leave the current view in place.
    return false;
  }

  if (!account) {
    // Clear any profile left over from a previous session: `App.vue` renders the authenticated
    // chrome off `profile`, so a stale one keeps the menu bar around the login form.
    useAccount().$reset();

    if (!["login", "register"].includes(to.name! as string)) {
      return { name: "login" };
    }

    return;
  }

  const store = useAccount();

  store.setBalance(account.balance);
  store.setFeatures(account.features);
  store.setProfile(account.profile);

  // An authenticated visitor has nothing to do on the login or register screen.
  if (["login", "register"].includes(to.name as string)) {
    return { name: "home" };
  }
});

export default router;
